// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SortableContract = contract({
  name: "Sortable",
  description: "Drag-to-reorder lists, kanban-column reordering, sortable shelves, tab strips the user can rearrange. Pairs with any layout primitive — Stack for vertical lists, Row for horizontal strips, Grid for 2D card walls. For cross-container drag (drag a card from one column to another) hand-roll DndContext at the page level — Sortable v1 covers single-list reorder; Sortable.Group for cross-container is a planned follow-up. Reach for raw `@dnd-kit/core` if you need custom collision detection, drag overlays with arbitrary chrome, or non-list use cases (kanban swimlanes, draggable canvas nodes).",
  import: "@gradeui/ui",
  aliases: ["sortable","reorder","drag and drop","dnd","draggable list","sortable list","kanban","drag to reorder","drag-drop","dragdroplist","drag handle","react native draggable flatlist"],
  subcomponents: ["Sortable.Item","Sortable.Handle"],
  composesWith: ["Stack (vertical lists)","Row (horizontal strips)","Grid (2D card walls)","Card (typical item content)","Button (as Sortable.Handle asChild)"],
  styleDefaults: {"SortableHandle":"cursor-grab touch-none select-none"},
  props: {
  "values": {
      schema: z.unknown(),
      design: "plumbing",
      description: "ordered list of unique ids; the source of truth for the order",
  },
  "onReorder": {
      schema: z.unknown().optional(),
      design: "event",
      description: "fires with the new order after a drag that changed it",
  },
  "strategy": {
      schema: z.enum(["vertical", "horizontal", "grid"]).optional(),
      design: "knob",
      description: "match the layout your items render in",
      default: "vertical",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "disable drag on every item",
  },
  "value": {
      schema: z.union([z.string(), z.number()]).optional(),
      design: "knob",
      description: "must match one entry in the parent `values` array (identity, not React key)",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Radix Slot",
  },
  },
});
